<script>
import { ZIndex } from "@primeuix/utils/zindex";
import Dialog from "primevue/dialog";

export default {
  extends: Dialog,
  watch: {
    baseZIndex: {
      handler(val) {
        if (this.mask) {
          ZIndex.set(
            "modal",
            this.mask,
            this.$primevue.config.zIndex.modal + parseInt(val, 10),
          );
        }
      },
    },
  },
  methods: {
    onMaskClick(event) {
      Dialog.methods.onMaskClick.call(this, event);
      this.$emit("requestWindowOverlap", event);
    },
  },
};
</script>
